module.exports = __webpack_public_path__ + "img/ice_cold_shot_green.1c9ff715.png";